let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hK4oO")).then(() => parcelRequire('lNMcW'));